import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { TCMLogo } from "./TCMLogo";

/**
 * Consistent top bar for internal pages: transparent TCM logo top-left,
 * an optional eyebrow next to it, and any actions on the right.
 *
 * Props:
 *   eyebrow  – small uppercase label next to the mark ("Portal Management", "Templates" …)
 *   backTo   – path to navigate back to; renders a "Back" pill on the far right
 *   children – arbitrary right-side actions (buttons, etc.)
 *   compact  – if true, uses a tighter vertical rhythm
 */
export function PortalHeader({ eyebrow, backTo, children, compact = false }) {
  const nav = useNavigate();
  const pad = compact ? "py-3" : "py-4";
  return (
    <div className={`border-b border-[color:var(--tcm-navy-15)] px-6 lg:px-8 ${pad} flex items-center gap-4 bg-[color:var(--tcm-cream)]`}
         data-testid="portal-header">
      <Link to="/" className="flex items-center gap-4 shrink-0" aria-label="The Curated Mile — Home">
        <TCMLogo size={compact ? "sm" : "md"} />
      </Link>
      {eyebrow && <span className="tcm-eyebrow hidden sm:inline">{eyebrow}</span>}
      <div className="flex-1" />
      <div className="flex items-center gap-2 flex-wrap justify-end">
        {children}
        {backTo && (
          <button
            data-testid="portal-header-back"
            onClick={() => nav(backTo)}
            className="tcm-btn-outline text-[11px] py-2 px-3">
            Back
          </button>
        )}
      </div>
    </div>
  );
}

export default PortalHeader;
